import React from 'react';
import NotoLogoImg from '../Images/NotoLogo.png';
const NotoLogo = (props) => {
    return (
        <img className="img-fluid" src={NotoLogoImg} alt="TrialStat" />
    );
};
export default NotoLogo;
